import { z } from 'zod';
import { errorMap } from 'zod-validation-error';

import { deepCopy, getErrorKeys, removeKeysFromObject } from '../optionsSchemaUtils';
import { DocumentCollectorElementOptions } from './DocumentCollectorElement';

const DISPLAY_MODES = ['full-screen', 'container'] as const;

export const DocumentCollectorOptionsSchema = z.object({
  collectionId: z.string().trim().min(1),
  collectionToken: z.string().trim().min(1),
  displayMode: z.enum(DISPLAY_MODES).optional(),
  detectDuplicateFiles: z.boolean().optional()
});

export const parseDocumentCollectorOptions = (options: DocumentCollectorElementOptions) => {
  const mandatoryResult = DocumentCollectorOptionsSchema.safeParse(options, { errorMap });
  const initialOptions = deepCopy(options);

  if (
    !mandatoryResult.success &&
    (mandatoryResult.error.flatten().fieldErrors['collectionId'] ||
      mandatoryResult.error.flatten().fieldErrors['collectionToken'])
  ) {
    return { errors: mandatoryResult.error.errors };
  }

  const errorKeys = getErrorKeys(mandatoryResult.error?.errors || []);
  const sanitizedOptions = removeKeysFromObject(options, errorKeys);

  return !mandatoryResult.success
    ? {
        warnings: mandatoryResult.error.flatten().fieldErrors,
        options: sanitizedOptions as DocumentCollectorElementOptions,
        initialOptions
      }
    : {
        options: mandatoryResult.data as DocumentCollectorElementOptions,
        initialOptions
      };
};
